module.exports = __webpack_public_path__ + "img/logo-Infinitec-Color.e539b019.png";